import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_370: DocMigration = {
  maxSchemaVersion: "0.0.370",
  description: "Add default drawing view template to doc",
  apply(json: any) {
    const viewTemplateId = uid();

    json.viewTemplates[viewTemplateId] = {
      entityType: "VIEW_TEMPLATE",
      id: viewTemplateId,
      name: "Drawing",
      viewType: "DRAWING",
      sortIndex: Math.min(...Object.values(json.viewTemplates).map((viewTemplate: any) => viewTemplate.sortIndex)) - 1,
      categories: [
        "ANNOT_DIM_LABEL",
        "ANNOT_DIM_LINEWORK",
        "ANNOT_DIM_TICK",
        "ANNOT_DIM_WITNESS",
        "ANNOTATION",
        "ANNOT_DETAIL",
        "ANNOT_LINEWORK",
        "ANNOT_NOTE",
      ],
      viewTemplateOverrideIds: [],
      styleOverrides: {},
    };

    return json;
  },
};

export default migration_0_0_370;
